import { render, staticRenderFns } from "./EventDetailsTabResponses.vue?vue&type=template&id=1942d866"
import script from "./EventDetailsTabResponses.vue?vue&type=script&lang=js"
export * from "./EventDetailsTabResponses.vue?vue&type=script&lang=js"
import style0 from "./EventDetailsTabResponses.vue?vue&type=style&index=0&id=1942d866&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports